<template>
  <div class="card-middle">
    <div class="card-middle-box">
      <div class="card-middle-left">
        <img :src="cardInfo.logo" class="card-middle-head" alt />
        <div class="card-middle-title cell_bk">
          {{ cardInfo.title }}
        </div>
        <div class="card-middle-tag">
          <template v-if="cardInfo.type === 'quiz'">
            <i class="answer" />{{ cardInfo.typeString || '答题' }}
          </template>
          <template v-if="cardInfo.type === 'content'">
            <i class="content" />{{ cardInfo.typeString || '内容' }}
          </template>
        </div>
        <div class="card-middle-content">
          {{ cardInfo.desc }}
        </div>
      </div>
      <PhoneModel
        class="card-middle-right"
        :image="cardInfo.poster[0]"
        :qrcode="cardInfo.qrCode"
        show-create
        :phone-style="cardInfo.style"
        @createPublication="$emit('createPublication')"
      />
    </div>
  </div>
</template>

<script>
import PhoneModel from 'src/components/preview/iPhoneX'

export default {
  components: {
    PhoneModel,
  },
  props: {
    cardInfo: {
      type: Object,
      default: () => {},
    },
  },
  data: function() {
    return {
      showQrCode:
        navigator.userAgent.match(/MicroMessenger/i) ||
        document.body.clientWidth > 500,
    }
  },
  computed: {},
  created() {},
}
</script>

<style lang="scss">
.card-middle {
  width: 550px;
  height: 519px;
  display: block;
  float: left;
  margin: 0 20px 30px 0;
  box-sizing: border-box;

  * {
    box-sizing: border-box;
  }

  .card-middle-box {
    position: relative;
    width: 100%;
    height: 345px;
    background: #fff;
    margin: 173px 0 0;

    .card-middle-left {
      display: flex;
      flex-direction: column;
      align-items: center;
      position: absolute;
      top: 36px;
      left: 25px;
      width: 240px;
      height: 265px;

      .card-middle-head {
        width: 56px;
        height: 56px;
        border-radius: 56px;
        display: block;
        margin-bottom: 16px;
      }

      .card-middle-title {
        width: 100%;
        line-height: 24px;
        height: 24px;
        text-align: center;
        margin-bottom: 71px;
        color: #000;
        font-size: 16px;
        overflow: hidden;
        text-overflow: ellipsis;
        -o-text-overflow: ellipsis;
        -webkit-text-overflow: ellipsis;
        -moz-text-overflow: ellipsis;
        white-space: nowrap;
      }

      .card-middle-tag {
        width: 100%;
        height: 20px;
        line-height: 20px;
        text-align: center;
        color: #000;
        font-size: 14px;

        i {
          width: 16px;
          height: 16px;
          background-repeat: no-repeat;
          background-size: 100%;
          display: inline-block;
          margin: 0 5px -2.5px 0;
        }

        i.answer {
          background-image: url('~static/icon/qingmang-answer.svg');
        }

        i.content {
          background-image: url('~static/icon/qingmang-content.svg');
        }

        i.comment {
          background-image: url('~static/icon/qingmang-comment.svg');
        }

        i.news {
          background-image: url('~static/icon/qingmang-news.svg');
        }
      }

      .card-middle-content {
        width: 100%;
        height: 40px;
        line-height: 20px;
        text-align: center;
        margin: 8px 0 20px;
        color: #666;
        font-size: 14px;
        padding: 16px 0 0;
        border-top: 1px solid #ddd;
        margin: 16px 0 0;
        //overflow: hidden;
        //text-overflow: ellipsis;
        display: -webkit-box;
        //-webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        box-sizing: initial;
      }
    }

    .card-middle-img {
      width: 245px;
      height: 493px;
      display: block;
      position: absolute;
      bottom: 24px;
      right: 24px;
      box-shadow: 0 5px 16px rgba(0, 0, 0, 0.06);
      box-sizing: initial;
    }
  }

  .card-middle-qrcode {
    width: 250px;
    height: 541px;
    display: block;
    position: absolute;
    bottom: 28px;
    right: 28px;
    box-shadow: 0px 5px 16px rgba(0, 0, 0, 0.06);
    box-sizing: initial;
    background: #fff;
    opacity: 0;
    transition: opacity 0.4s;

    img {
      width: 120px;
      height: 120px;
      display: block;
      float: left;
      margin: 60px 65px 20px;
    }

    span {
      width: 100%;
      height: 20px;
      line-height: 20px;
      font-size: 14px;
      text-align: center;
      display: block;
      float: left;
      color: #999;
    }

    em {
      width: 160px;
      height: 48px;
      line-height: 48px;
      font-size: 14px;
      text-align: center;
      display: block;
      float: left;
      color: #fff;
      background: #000;
      margin: 140px 45px 0;
      cursor: pointer;
    }
  }

  .card-middle-right {
    position: absolute;
    transform: translate(22.5%, 22.5%) scale(0.55, 0.55);
    right: 30px;
    bottom: 30px;
  }
}

@media screen and (max-width: 500px) {
  .card-middle123 {
    width: 90%;
    height: auto;
    display: block;
    float: left;
    margin: 35px 5% 0;
    position: relative;

    .card-middle-box {
      width: 100%;
      height: 450px;
      background: #fff;
      margin: 123px 0 0;
      position: initial;

      .card-middle-left {
        width: 82%;
        height: auto;
        display: block;
        position: absolute;
        top: 310px;
        left: 9%;

        .card-middle-head {
          width: 56px;
          height: 56px;
          border-radius: 56px;
          display: block;
          margin: 0 auto;
        }

        .card-middle-title {
          width: 100%;
          height: 68px;
          line-height: 34px;
          text-align: center;
          margin: 8px 0 10px;
          color: #000;
          font-size: 24px;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
        }

        .card-middle-tag {
          width: 100%;
          height: 20px;
          line-height: 20px;
          text-align: center;
          color: #000;
          font-size: 14px;

          i {
            width: 16px;
            height: 16px;
            background-repeat: no-repeat;
            background-size: 100%;
            display: inline-block;
            margin: 0 5px -2.5px 0;
          }

          i.answer {
            background-image: url('~static/icon/qingmang-answer.svg');
          }

          i.comment {
            background-image: url('~static/icon/qingmang-comment.svg');
          }

          i.news {
            background-image: url('~static/icon/qingmang-news.svg');
          }
        }

        .card-middle-content {
          width: 100%;
          height: 40px;
          line-height: 20px;
          text-align: center;
          margin: 8px 0 20px;
          color: #666;
          font-size: 14px;
          padding: 16px 0 0;
          border-top: 1px solid #ddd;
          margin: 16px 0 0;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
        }
      }

      .card-middle-righ {
        width: 100%;
        height: auto;
        display: block;
        float: left;
        text-align: center;
        position: absolute;
        top: 0;
        left: 0;

        .card-middle-img {
          width: 41%;
          height: auto;
          display: inline-table;
          position: relative;
          bottom: auto;
          right: auto;
          box-shadow: 0px 5px 16px rgba(0, 0, 0, 0.06);
          box-sizing: initial;
        }

        .card-middle-qrcode {
          display: inline-table;
          width: 18%;
          height: auto;
          margin: 0 0 0 5%;
          position: relative;
          bottom: auto;
          right: auto;
          box-shadow: none;
          opacity: 1;

          img {
            width: 100%;
            height: auto;
            display: block;
            float: left;
            margin: auto;
          }

          span {
            width: 100%;
            height: auto;
            display: block;
            float: left;
            text-align: center;
            font-size: 10px;
            color: #999;
            margin-top: 5px;
          }

          em {
            display: none;
          }
        }
      }
    }
  }
}
</style>
